import React from "react";
import { Form, FormInstance, Input, Button, Result, notification } from "antd";
import { Link } from "react-router-dom";
import { withRouter } from "./../../../utils/withRouter";
import { withTranslation } from "react-i18next";
import "./style/Forgot.css";
import api from "../../../const/axios";
import { SmileOutlined, FrownOutlined } from "@ant-design/icons";
import history from "./../../../const/history";

class Reset extends React.Component<any> {
  formRef = React.createRef<FormInstance<any>>();
  
  state = {
    isGood: false,
    confirmDirty: false,
  };
  
  componentDidMount() {
    if (this.props.params.code && this.props.params.email) {
      this.setState({
        isGood: true,
      });
    }
  }

  handleSubmit = async (values) => {
    try {
      const res = await api.put(
        "auth/forgot",
        JSON.stringify({ ...this.props.params, ...values })
      );
      
      if (res.data.success) {
        notification.info({
          message: this.props.t('auth.operationSuccess'),
          description: res.data.message,
          placement: "bottomRight",
          icon: <SmileOutlined />,
        });
        history.push("/");
      } else {
        notification.info({
          message: this.props.t('auth.operationFailed'),
          description: res.data.message,
          placement: "bottomRight",
          icon: <FrownOutlined />,
        });
      }
    } catch (error) {
      notification.error({
        message: this.props.t('auth.errorOccurred'),
        description: this.props.t('auth.operationError'),
        placement: "bottomRight",
      });
    }
  };

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  render() {
    const { t } = this.props;
    
    return (
      <div className="b-container page">
        {this.state.isGood ? (
          <div className="loginForm">
            <h3 className="page-name">{t('auth.resetPassword')}</h3>
            <Form 
              ref={this.formRef} 
              onFinish={this.handleSubmit} 
              className="login-form reset-form"
            >
              <Form.Item 
                name="password"
                hasFeedback 
                className="reset-item"
                validateTrigger="onBlur"
                rules={[
                  {
                    required: true,
                    message: t('auth.passwordRequired'),
                  },
                  {
                    min: 8,
                    message: t('auth.passwordMinLength'),
                  },
                ]}
              >
                <Input.Password placeholder={t('auth.newPassword')} />
              </Form.Item>
              <Form.Item 
                name="confirm"
                hasFeedback 
                className="reset-item"
                validateTrigger="onBlur"
                dependencies={['password']}
                rules={[
                  {
                    required: true,
                    message: t('auth.confirmPasswordRequired'),
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(t('auth.passwordsNotMatch')));
                    },
                  }),
                ]}
              >
                <Input.Password
                  onBlur={this.handleConfirmBlur}
                  placeholder={t('auth.confirmPassword')}
                />
              </Form.Item>
              <Form.Item className="forgot-form-row">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  style={{ width: "100%" }}
                >
                  {t('auth.changePassword')}
                </Button>
              </Form.Item>
            </Form>
          </div>
        ) : (
          <Result
            status="404"
            title="404"
            subTitle={t('common.pageNotFound')}
            extra={
              <Button type="primary">
                <Link to="/">{t('common.homePage')}</Link>
              </Button>
            }
          />
        )}
      </div>
    );
  }
}

export default withTranslation()(withRouter(Reset));
